let responses = [
  { code: "00", description: "Aprobada" },
  { code: "01", description: "Refiérase al emisor" },
  { code: "02", description: "Refiérase al emisor" },
  { code: "05", description: "Transacción no aceptada" },
  { code: "12", description: "Transacción inválida" },
  { code: "13", description: "Monto inválido" },
  { code: "19", description: "Transacción no realizada, intente de nuevo" },
  { code: "31", description: "Tarjeta no soportada por switch" },
  { code: "35", description: "Transacción ya ha sido anulada" },
  { code: "36", description: "Transacción a anular no existe" },
  { code: "37", description: "Transaccioń de anulación reversada" },
  { code: "38", description: "Transacción a anular con error" },
  { code: "41", description: "Tarjeta extraviada" },
  { code: "43", description: "Tarjeta robada" },
  { code: "51", description: "No tiene fondos disponibles" },
  { code: "57", description: "Transacción no permitida" },
  { code: "58", description: "Transacción no permitida en la terminal" },
  { code: "65", description: "Límite de actividad excedido" },
  { code: "80", description: "Fecha de expiración inválida" },
  { code: "89", description: "Terminal inválida" },
  { code: "91", description: "Emisor no disponible" },
  { code: "94", description: "Transacción duplicada" },
  { code: "96", description: "Error del sistema, intente más tarde" },
];

module.exports = responses;
